{
  "version": 1,
  "asset_id": "e579f58d-e84f-4ac8-8926-8389e97c0d48",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/e579f58d-e84f-4ac8-8926-8389e97c0d48/process-1280.avif",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/e579f58d-e84f-4ac8-8926-8389e97c0d48/process-1280.avif",
  "original_filename": "process-1280.avif",
  "size": 30620,
  "content_type": "image/avif",
  "created_at": "2026-07-25T02:26:38Z"
}
